import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { reApi, errMsg } from "@/lib/residentApi";
import { finApi } from "@/lib/financeApi";
import ProfileTab from "@/components/nds/windows/resident/ProfileTab";
import MemoBoardTab from "@/components/nds/windows/resident/MemoBoardTab";
import CalendarTab from "@/components/nds/windows/resident/CalendarTab";
import FinancialTab from "@/components/nds/windows/resident/FinancialTab";
import PillarFixPanel from "@/components/nds/PillarFixPanel";
import ReviewPanel from "@/components/nds/windows/pillar/ReviewPanel";
import WorkflowContent from "@/components/nds/windows/finance/WorkflowContent";
import { INCIDENT_CFG } from "@/components/nds/windows/ReIncidentsContent";
import { OwedPaychecks } from "@/components/nds/windows/finance/OwedPaychecks";

const TAB = { schedule: CalendarTab, rent: FinancialTab, memos: MemoBoardTab, room: ProfileTab, intake: ProfileTab };

function ResidentOwed({ residentId, onChanged }) {
  const [d, setD] = useState(null);
  const load = () => finApi.get("/paychecks-owed").then((x) => { const owed = x.owed.filter((o) => o.resident_id === residentId); setD({ owed, count: owed.length, total: owed.reduce((s, o) => s + o.line_pay, 0) }); });
  useEffect(() => { load(); }, [residentId]); // eslint-disable-line react-hooks/exhaustive-deps
  return d ? <OwedPaychecks data={d} reload={() => { load(); onChanged(); }} /> : <Loader2 className="h-4 w-4 animate-spin" />;
}

function ResidentTab({ Tab, residentId, onChanged }) {
  const [res, setRes] = useState(null);
  const [err, setErr] = useState(null);
  const load = () => reApi.get(`/residents/${residentId}`).then(setRes).catch((e) => setErr(errMsg(e)));
  useEffect(() => { load(); }, [residentId]); // eslint-disable-line react-hooks/exhaustive-deps
  if (err) return <p className="text-xs text-red-300">{err}</p>;
  return res ? <Tab resident={res} manage onChanged={() => { load(); onChanged(); }} /> : <Loader2 className="h-4 w-4 animate-spin" />;
}

/** The fix for one check-in area, opened right under it. */
export default function AreaFix({ area, residentId, residentName, onChanged, onClose }) {
  if (area === "pillars") return <PillarFixPanel residentId={residentId} onChanged={onChanged} />;
  if (area === "review") return <ReviewPanel resident={{ resident_id: residentId, name: residentName }} onClose={onClose} onSaved={onChanged} />;
  if (area === "paychecks") return <ResidentOwed residentId={residentId} onChanged={onChanged} />;
  if (area === "incidents") return <div className="-mx-4"><WorkflowContent cfg={INCIDENT_CFG} initial={{ only: residentId }} /></div>;
  if (TAB[area]) return <ResidentTab Tab={TAB[area]} residentId={residentId} onChanged={onChanged} />;
  return null;
}
